var _style, _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTamsLogoNuevo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tams_logo_color",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77.9 23",
    style: {
      enableBackground: "new 0 0 77.9 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#94CC78;} ", "\r\n\t.st1{fill:#00A3B8;} ", "\r\n\t.st2{fill:#286D76;}\r\n\t.st3{fill:none;stroke:#94CC78;stroke-width:0.166;stroke-miterlimit:10;}\r\n\t.rebrading-verde { fill: #286D76;\t}\r\n\t @media (prefers-color-scheme: dark) { .rebrading-verde {fill: #30A5AA; }\t}\t\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    className: "st0",
    d: "M9,15.3l8.1,8.1l3-11.1l-4.8,4.2L9,15.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    className: "st1",
    d: "M20.3,11l2.9-11l-11,3l6,2L20.3,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st2",
    d: "M8,14.3L0,6.2l11.1-3L6.8,8L8,14.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    transform: "translate(27.959 2.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    className: "rebrading-verde",
    d: "M11,0.2v2.1H6.8v11.8H4.3V2.3H0V0.2H11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "rebrading-verde",
    d: "M22.8,14.2h-2c-0.2,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.2-0.2-0.3-0.4l-1-2.9h-5.8l-1,2.9 c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0.1-0.4,0.2-0.6,0.2h-2l5.5-13.9h2.6L22.8,14.2z M13.8,8.8h4.5l-1.7-4.6c-0.1-0.2-0.2-0.5-0.2-0.7 c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1,0.3-0.2,0.6-0.3,0.9c-0.1,0.2-0.2,0.5-0.2,0.7L13.8,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    className: "rebrading-verde",
    d: "M31.1,9c0.1,0.2,0.2,0.5,0.3,0.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.2-0.4,0.3-0.6l4.1-7.7 c0-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.1s0.2-0.1,0.2-0.1h2.2v13.9h-2.3V4.6c0-0.2,0-0.4,0.1-0.6l-4.2,7.9 c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.2-0.5,0.2h-0.3c-0.2,0-0.4,0-0.5-0.2c-0.2-0.1-0.3-0.2-0.4-0.4L26,3.9 C26,4.1,26,4.3,26,4.5v9.6h-2.3V0.2H26c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.2l4.2,7.8 C30.9,8.5,31,8.7,31.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "rebrading-verde",
    d: "M48.9,2.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.5-0.2 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.7-0.2-1-0.2c-0.3,0-0.6,0-0.9,0.1c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.2,0.2-0.3,0.3-0.4,0.6c-0.1,0.2-0.1,0.5-0.1,0.7c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.4,0.7,0.6c0.3,0.2,0.7,0.3,1,0.4 c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.1,0.8,0.3,1.2,0.5c0.4,0.2,0.7,0.4,1,0.7c0.3,0.3,0.6,0.6,0.7,1c0.2,0.5,0.3,1,0.3,1.5 c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.5-0.5,1-1,1.4c-0.4,0.4-1,0.8-1.5,1c-0.7,0.2-1.4,0.4-2.1,0.3c-0.4,0-0.9,0-1.3-0.1 c-0.5-0.1-0.9-0.2-1.3-0.3c-0.4-0.2-0.7-0.3-1.1-0.6c-0.3-0.2-0.6-0.5-0.9-0.7l0.7-1.3c0.1-0.1,0.2-0.2,0.2-0.2 c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.3,0.7,0.5c0.3,0.2,0.6,0.3,0.9,0.5c0.4,0.1,0.8,0.2,1.3,0.2 c0.6,0,1.2-0.1,1.7-0.5c0.4-0.4,0.7-0.9,0.6-1.5c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.2-0.5-0.4-0.7-0.6c-0.3-0.2-0.7-0.3-1-0.4l-1.2-0.3 c-0.4-0.1-0.8-0.3-1.2-0.5c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.6-0.7-0.7-1.1C41.1,5.1,41,4.5,41,4c0-0.5,0.1-1,0.3-1.5 c0.2-0.5,0.5-0.9,0.9-1.3c0.4-0.4,0.9-0.7,1.4-0.9C44.2,0.1,44.9,0,45.5,0c0.8,0,1.6,0.1,2.3,0.4c0.7,0.2,1.3,0.6,1.8,1.1L48.9,2.7 z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st3",
    d: "M18,5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "st3",
    d: "M15.4,9.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st3",
    d: "M15.4,9.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamsLogoNuevo);
export default __webpack_public_path__ + "static/media/tams_logo_nuevo.fac43cc68bcb665fe386da03cbf16de4.svg";
export { ForwardRef as ReactComponent };